import { BASE_URL_INVENTORY } from '../../CONSTANTS';
import { callGetAxios } from '../common/common';

export const logItemPriceListHistory = (priseListId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logItemPriseListHistory/getItemPriseListHistory/' + priseListId, 'logItemPriceListHistory');
};

export const logVendorHistory = (vendorId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logVendorHistory/getVendorHistory/' + vendorId, 'logVendorHistory');
};

export const logSalesPaymentHistory = (paymentId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logSalesPaymentHistory/getSalesPaymentHistory/' + paymentId, 'logSalesPaymentHistory');
};

export const logSalesOrderHistory = (salesOrderNo) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logSalesOrderHistory/getSalesOrderHistory/' + salesOrderNo, 'logSalesOrderHistory');
};

export const logRecipeHistory = (recipeId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logRecipeHistory/getRecipeHistory/' + recipeId, 'logRecipeHistory');
};

export const logPurchasePaymentHistory = (paymentId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logPurchasePaymentHistory/getPurchasePaymentHistory/' + paymentId, 'logPurchasePaymentHistory');
};
export const logPurchaseOrderHistory = (purchaseOrderNo) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logPurchaseOrderHistory/getPurchaseOrderHistory/' + purchaseOrderNo, 'logPurchaseOrderHistory');
};
export const logItemHistory = (itemId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logItemHistory/getItemHistory/' + itemId, 'logItemHistory');
};

export const logIssuanceHistory = (issuanceCode) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logIssuanceHistory/getIssuanceHistory/' + issuanceCode, 'logIssuanceHistory');
};
export const logInvoiceHistory = (invoiceNo) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logInvoiceHistory/getInvoiceHistory/' + invoiceNo, 'logInvoiceHistory');
};
export const logCustomerHistory = (customerId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logCustomerHistory/getCustomerHistory/' + customerId, 'logCustomerHistory');
};

export const logBillHistory = (billNo) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logBillHistory/getBillHistory/' + billNo, 'logBillHistory');
};

export const logBatchesHistory = (batchesId) => {
    return callGetAxios(BASE_URL_INVENTORY + 'logBatchesHistory/getBatchesHistory/' + batchesId, 'logBatchesHistory');
};
